import { string, z } from "zod";
import { createApiResponseSchema } from "../../types/common/pagination";
import { FormalityFormSchema } from "@/types/entities/formality-request";

export const ResolutionSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  code: z.string(),
  status: z.string().nullable(),
  description: z.string().nullable(),
  resolution_date: z.string().nullable(),
  formality_request_id: z.uuid().nullable(),
  applicant_id: z.uuid().nullable(),
  is_manual: z.boolean(),
  display_name: z.string().nullable(),
  display_code: z.string().nullable(),
  display_date: z.string().nullable(),
  formality_request: FormalityFormSchema.nullable(),
  files: z.array(
    z.object({
      id: string(),
      name: string(),
      file_name: string(),
      url: string(),
    }),
  ),
  applicant: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
});

export type ResolutionType = z.infer<typeof ResolutionSchema>;

export const ApiResolutionResponseSchema =
  createApiResponseSchema(ResolutionSchema);
export type ApiResolutionResponseType = z.infer<
  typeof ApiResolutionResponseSchema
>;

export const ResolutionFormSchema = z.object({
  name: z.string().min(1, "El nombre es obligatorio"),
  code: z.string().min(1, "El ID de solicitud es obligatorio"),
  resolution_date: z.string().min(1, "La fecha es obligatoria"),
  description: z.string().min(1, "El nombre del trámite es obligatorio"),
  files: z.custom<File[]>((val) => {
    if (!val) return false;
    if (Array.isArray(val) && val.length > 0) return true;
    return false;
  }, "Debe subir al menos un archivo"),
  status: z.string().optional(),
});

export type ResolutionFormData = z.infer<typeof ResolutionFormSchema>;
